import { render, staticRenderFns } from "./LocaleSettings.vue?vue&type=template&id=4528241e&"
import script from "./LocaleSettings.vue?vue&type=script&lang=js&"
export * from "./LocaleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports